export default "__VITE_ASSET__M3obb8q4__"